import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PlatformMapsService {

  constructor(private platform: Platform) {}

  getMapsApiKey(): string {
    if (this.platform.is('android')) {
      return environment.mapsKey.android;
    } else if (this.platform.is('ios')) {
      return environment.mapsKey.ios;
    } else {
      // Default to web for browser/PWA
      return environment.mapsKey.web;
    }
  }

  getCurrentPlatform(): string {
    if (this.platform.is('android')) {
      return 'android';
    } else if (this.platform.is('ios')) {
      return 'ios';
    } else {
      return 'web';
    }
  }
}
